import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import { useHistory } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import { MdlFiltrosScreen } from "./MdlFiltrosScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import Swal from "sweetalert2";
import DownloadingIcon from "@mui/icons-material/Downloading";
import { BuroCard } from "./BuroCard";

export const ReporteBuroCredito = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [ejercicio, setEjercicio] = useState("");
  const [periodo, setPeriodo] = useState("");
  var nombreperiodo;
  const [selectedRows, setSelectedRows] = useState({});
  const [selectedClientIds, setSelectedClientIds] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [defaultSortConfig, setDefaultSortConfig] = useState({
    key: "razon_social",
    direction: "asc",
  });
  const totalClientesEncontrados = data.length;
  const [cardSelected, setCardSelected] = useState(1);
  const [estado, setEstado] = useState(() => {
    const savedState = localStorage.getItem("filtroEstado");
    return savedState
      ? JSON.parse(savedState)
      : {
          ejercicio: "",
          periodo: "",
          lineacredito: "",
          vencimiento: "",
          registrado: "",
          mostrar: false,
        };
  });

  const [mostrarFiltro, setMostrarFiltro] = useState(false);

  const onHome = () => {
    history.push("/Credito/Main");
  };

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const handleCargarRecuperacion = (state) => {
    const filtroinfo = {
      ejercicio: state.ejercicio,
      periodo: state.periodo,
      linea: state.lineacredito,
      vencimiento: state.vencimiento,
      registrado: state.registrado,
      domicilio: state.domicilio,
    };
    setLoader({ ...loader, mostrar: true });
    return request
      .post(`CargaReporteBuro/Cargar`, filtroinfo)
      .then((result) => {
        // console.log(result);
        setLoader({ ...loader, mostrar: false });
        setData(result);
        setEjercicio(state.ejercicio);
        setPeriodo(state.periodo);
        setEstado(state);
        localStorage.setItem("filtroEstado", JSON.stringify(state));
        setMostrarFiltro(false);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
      });
  };

  const onGeneraExcel = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      ejercicio: Number(estado.ejercicio),
      periodo: Number(estado.periodo),
      mes: nombreperiodo,
      linea: estado.lineacredito,
      vencimiento: estado.vencimiento,
      registrado: estado.registrado,
      domicilio: estado.domicilio,
    };
    request
      .post(`CargaReporteBuro/GenerarExcel`, post)
      .then(({ documento, filename }) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const onGeneraExcelInforme = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      ejercicio: Number(estado.ejercicio),
      periodo: Number(estado.periodo),
      mes: nombreperiodo,
      linea: estado.lineacredito,
      vencimiento: estado.vencimiento,
      registrado: estado.registrado,
      domicilio: estado.domicilio,
    };
    request
      .post(`CargaReporteBuro/GenerarExcelInforme`, post)
      .then(({ documento, filename }) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const onGuardarNoReportados = () => {
    setLoader({ ...loader, mostrar: true });
    const mdl = {
      idcliente: JSON.stringify(selectedClientIds),
    };

    request
      .post(`GuardaClientesNoReportados/Guardar`, mdl)
      .then((response) => {
        setLoader({ ...loader, mostrar: false });
        setSelectedRows({});
        setSelectedClientIds([]);
        handleCargarRecuperacion(estado); // Asegúrate de pasar el estado correcto aquí
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const getRowClass = (item) => {
    let rowClass = "";

    if (!item.registrado) {
      rowClass += " bg-red";
    } else if (!item.domicilio) {
      rowClass += " bg-yellow";
    }

    if (selectedRows[item.idcliente]) {
      rowClass += " selected";
    }

    if (item.reporta_buro === true) {
      rowClass += " tc-red";
    }
    return rowClass;
  };

  switch (periodo) {
    case 1:
      nombreperiodo = "ENERO";
      break;
    case 2:
      nombreperiodo = "FEBRERO";
      break;
    case 3:
      nombreperiodo = "MARZO";
      break;
    case 4:
      nombreperiodo = "ABRIL";
      break;
    case 5:
      nombreperiodo = "MAYO";
      break;
    case 6:
      nombreperiodo = "JUNIO";
      break;
    case 7:
      nombreperiodo = "JULIO";
      break;
    case 8:
      nombreperiodo = "AGOSTO";
      break;
    case 9:
      nombreperiodo = "SEPTIEMBRE";
      break;
    case 10:
      nombreperiodo = "OCTUBRE";
      break;
    case 11:
      nombreperiodo = "NOVIEMBRE";
      break;
    case 12:
      nombreperiodo = "DICIEMBRE";
      break;

    default:
      nombreperiodo = "";

      break;
  }

  const sortedData = React.useMemo(() => {
    if (!Array.isArray(data)) {
      return [];
    }

    let sortableItems = [...data];
    const { key, direction } = sortConfig || defaultSortConfig;
    if (key !== null) {
      sortableItems.sort((a, b) => {
        if (a[key] < b[key]) {
          return direction === "asc" ? -1 : 1;
        }
        if (a[key] > b[key]) {
          return direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [data, sortConfig, defaultSortConfig]);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    setDefaultSortConfig({ key, direction });
  };
  const fetchData = async () => {
    const result = await handleCargarRecuperacion(estado);
    if (Array.isArray(result)) {
      setData(result);
    } else {
    }
  };
  useEffect(() => {
    fetchData();
    handleCargarRecuperacion(estado);
  }, [estado.ejercicio, estado.periodo]);

  useEffect(() => {
    const uniqueKeys = new Set();
    const duplicates = sortedData.filter((item) => {
      if (uniqueKeys.has(item.idcliente)) {
        return true;
      }
      uniqueKeys.add(item.idcliente);
      return false;
    });
  }, [sortedData]);

  const CargaDetalle = (idcliente) => {
    const selectedClient = sortedData.find(
      (item) => item.idcliente === idcliente
    );
    history.push({
      pathname: "DetalleBuroCredito",
      state: { clientInfo: selectedClient },
    });
  };

  // console.log(data)

  //   console.log(selectedClientIds);
  // }, [selectedClientIds]);

  return (
    <PlantillaScreen
      titulo={`REPORTE DE BURO DE CREDITO ${nombreperiodo} ${ejercicio}`}
      className_main={1}
      className={"reporte-buro"}
    >
      <div className="reporte-buro-footer">
        <div className="home-bc" onClick={onHome}>
          <ArrowBackIcon /> Regresar
        </div>
        <div className="reporte-buro-footer-download">
          <button
            className="button-download-excel"
            onClick={onGeneraExcelInforme}
          >
            <DownloadingIcon />
            Informe Buro Crédito
          </button>
          <button className="button-download-excel" onClick={onGeneraExcel}>
            <DownloadingIcon />
            Generar Excel
          </button>
        </div>
        <MdlFiltrosScreen
          onCargarRecuperacion={handleCargarRecuperacion}
          estado={setEstado}
          recarga={false}
        />
      </div>

      <LoaderScreen loader={loader} />
      <div className="buro-container-scroll scroll-4">
        <div className="conteo-clientes">
          {`Se encontraron ${totalClientesEncontrados} cliente(s)`}
        </div>

        <div className="buro-container-total">
          <div className="buro-container-resumen">
            <BuroCard
              titulo={"TOTAL"}
              cantidad={0}
              className={"buro-container-resumen-item-click"}
              onClick={() => {
                // onExecuteCards(state.idcliente, 1);
                setCardSelected(1);
              }}
              porcentaje={"100%"}
              activo={cardSelected === 1 ? true : false}
            />
            <BuroCard
              titulo={"REVOLVENTE"}
              cantidad={0}
              className={"buro-container-resumen-item-click"}
              onClick={() => {
                // onExecuteCards(state.idcliente, 2);
                setCardSelected(2);
              }}
              porcentaje={0}
              //   `${FormatMoney(
              //   (totalRevolvente / totalConveniosEncontrados) * 100,
              //   0
              // )}%`}
              activo={cardSelected === 2 ? true : false}
            />
            <BuroCard
              titulo={"OPERACIÓN"}
              cantidad={0}
              className={"buro-container-resumen-item-click"}
              onClick={() => {
                // onExecuteCards(state.idcliente, 3);
                setCardSelected(3);
              }}
              porcentaje={0}
              //   `${FormatMoney(
              //   (totalOperacion / totalConveniosEncontrados) * 100,
              //   0
              // )}%`}
              activo={cardSelected === 3 ? true : false}
            />
            <BuroCard
              titulo={"PRESTAMOS"}
              cantidad={0}
              className={"buro-container-resumen-item-click"}
              onClick={() => {
                // onExecuteCards(state.idcliente, 4);
                setCardSelected(4);
              }}
              porcentaje={0}
              //   `${FormatMoney(
              //   (totalPrestamo / totalConveniosEncontrados) * 100,
              //   0
              // )}%`}
              activo={cardSelected === 4 ? true : false}
            />
            <BuroCard
              titulo={"NO ENVIADO"}
              cantidad={0}
              className={"buro-container-resumen-item-click"}
              onClick={() => {
                // onExecuteCards(state.idcliente, 4);
                setCardSelected(5);
              }}
              porcentaje={0}
              //   `${FormatMoney(
              //   (totalPrestamo / totalConveniosEncontrados) * 100,
              //   0
              // )}%`}
              activo={cardSelected === 5 ? true : false}
            />
          </div>
          <div className="reporte-buro-tabla scroll-4">
            <table cellPadding={0} cellSpacing={0}>
              <thead> 
                <tr className="tbl-bc-row1">
                  <th rowSpan={2}></th>
                  <th
                    className="razonsocial-encabezado"
                    rowSpan={2}
                    onClick={() => requestSort("razonsocial")}
                  >
                    Razon Social{" "}
                    {defaultSortConfig.key === "razonsocial" && (
                      <span>
                        {defaultSortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  <th
                    className="rfc-encabezado"
                    rowSpan={2}
                    onClick={() => requestSort("rfc")}
                  >
                    RFC{" "}
                    {sortConfig.key === "rfc" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  <th colSpan={4}>Crédito MHUSA</th>
                  <th colSpan={4}>Crédito Revolvente</th>
                  <th
                    className="registrado-encabezado"
                    rowSpan={2}
                    onClick={() => requestSort("registrado")}
                  >
                    Esta Registrado{" "}
                    {sortConfig.key === "registrado" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  <th
                    className="domicilio-encabezado"
                    rowSpan={2}
                    onClick={() => requestSort("domicilio")}
                  >
                    Tiene Domicilio{" "}
                    {sortConfig.key === "domicilio" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  {/* <th
                className="solicitud-encabezado"
                rowSpan={2}
                // onClick={() => requestSort("solicitud")}
              >
                Tiene Pedido
                {sortConfig.key === "solicitud" && (
                  <span>{sortConfig.direction === "asc" ? " ▲" : " ▼"}</span>
                )}
              </th> */}
                </tr>
                <tr className="tbl-bc-row2">
                  <th onClick={() => requestSort("fac_opercion")}>
                    Facturas{" "}
                    {sortConfig.key === "fac_opercion" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  <th onClick={() => requestSort("fac_o_vencidas")}>
                    Vencidas{" "}
                    {sortConfig.key === "fac_o_vencidas" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  <th onClick={() => requestSort("fac_o_porvencer")}>
                    Por vencer{" "}
                    {sortConfig.key === "fac_o_porvencer" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  <th onClick={() => requestSort("saldo_operacion")}>
                    Saldo{" "}
                    {sortConfig.key === "saldo_operacion" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  <th onClick={() => requestSort("fac_revolvente")}>
                    Facturas{" "}
                    {sortConfig.key === "fac_revolvente" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  <th onClick={() => requestSort("fac_r_vencidas")}>
                    Vencidas{" "}
                    {sortConfig.key === "fac_r_vencidas" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  <th onClick={() => requestSort("fac_r_porvencer")}>
                    Por vencer{" "}
                    {sortConfig.key === "fac_r_porvencer" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                  <th onClick={() => requestSort("saldo_revolvente")}>
                    Saldo{" "}
                    {sortConfig.key === "saldo_revolvente" && (
                      <span>
                        {sortConfig.direction === "asc" ? " ▲" : " ▼"}
                      </span>
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr
                    key={`${item.idcliente}-${index}`}
                    className={getRowClass(item)}
                    onClick={() => CargaDetalle(item.idcliente)}
                  >
                    <td>
                      {item.diversos === true && (
                        <div className="circle-red-td"></div>
                      )}
                    </td>
                    <td>{item.razonsocial}</td>
                    <td>{item.rfc}</td>
                    <td className="ta-center bl">
                      {item.op_fac_vencidas === 0 ? "-" : item.op_fac_vencidas}
                    </td>
                    <td className="ta-right">
                      {item.op_vencido === 0
                        ? "-"
                        : FormatMoney(item.op_vencido, 0)}
                    </td>
                    <td className="ta-center">
                      {item.op_porvencer === 0
                        ? "-"
                        : FormatMoney(item.op_porvencer, 0)}
                    </td>
                    <td className="ta-right fw-bold">
                      {item.op_vencido + item.op_porvencer === 0
                        ? "-"
                        : FormatMoney(item.op_vencido + item.op_porvencer, 0)}
                    </td>
                    <td className="ta-center bl">
                      {item.rev_fac_vencidas === 0
                        ? "-"
                        : item.rev_fac_vencidas}
                    </td>
                    <td className="ta-right">
                      {item.rev_vencido === 0
                        ? "-"
                        : FormatMoney(item.rev_vencido, 0)}
                    </td>
                    <td className="ta-right">
                      {item.rev_porvencer === 0
                        ? "-"
                        : FormatMoney(item.rev_porvencer, 0)}
                    </td>
                    <td className="ta-right fw-bold">
                      {item.rev_vencido + item.rev_porvencer === 0
                        ? "-"
                        : FormatMoney(item.rev_vencido + item.rev_porvencer, 0)}
                    </td>

                    <td className="ta-center bl">
                      {item.registrado ? "SI" : "NO"}
                    </td>
                    <td className="ta-center">
                      {item.domicilio === true ? "SI" : "NO"}
                    </td>
                    {/* <td className="ta-center">
                  {item.solicitud === true ? "SI" : "NO"}
                </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </PlantillaScreen>
  );
};
